import Swal from "sweetalert2";

function releaseBodyScroll() {
  document.body.style.overflow = "";
  document.body.style.paddingRight = "";
  document.documentElement.classList.remove("swal2-shown", "swal2-height-auto");
  document.body.classList.remove("swal2-shown", "swal2-height-auto");
}

export function fireSwal(options) {
  return Swal.fire({
    heightAuto: false,
    ...options,
    didClose: (...args) => {
      releaseBodyScroll();
      options?.didClose?.(...args);
    },
  });
}
